export default "__VITE_ASSET__BqslLKkE__"